<template>
  <div class="card" :class="{'card-plain': isPlain}">
    <div class="card-header" data-background-color="magenta-dark">
      <div class="row">
        <div class="col-md-6">
        </div>
      </div>
    </div>

    <div class="card-content table-responsive">
      <table class="table" :class="tableClass">
        <thead>
          <th> </th> <!-- For the radio checkbox -->
          <th v-for="column in columns">{{column}}</th>
        </thead>
        <tbody>  
          <tr v-for="item in data">
            <div class="form-check">
              <input class="form-check-input" name="radio" v-model="filaSelect" :value="item" type="radio">
            </div>
            <td v-for="column in columns" v-if="hasValue(item, column)">{{itemValue(item, column)}}</td>
          </tr>
        </tbody>
      </table>
      <div class="col-md-offset-10">
        <button type="button" @click="localizar" class="btn btn-primary">Localizar</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        columns: ['Index', 'Marca', 'Modelo', 'Dominio', 'Motor', 'Chasis', 'Servicio'],
        data: [{index: 1, marca: 'Ford', modelo: 'Focus', dominio: 'AABB445', motor: 'V8-7431', chasis: 'CHA111', servicio: 'Recupero'},
               {index: 2, marca: 'Ford', modelo: 'Focus', dominio: 'AABB445', motor: 'V8-7431', chasis: 'CHA111', servicio: 'Recupero'}],
        title: 'Vehículos encontrados',
        subTitle: '',
        filaSelect: null,
        show: false
      }
    },
    computed: {
      tableClass () {
        return `table-${this.type}`
      },
      isPlain () {
        return this.type === 'plain'
      }
    },
    methods: {
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      },
      localizar () {
        alert(JSON.stringify(this.filaSelect))
      }
    }
  }

</script>

<style>
  /*button {
    margin: 0 !important;
  }*/
</style>



// WEBPACK FOOTER //
// TableCar.vue?59c46bba